<div class="context-selector renaissance-style-scoped">
  <div data-test="Subject" class="filter">
    <mat-label>Subject</mat-label>
    <mat-form-field id="pendo-subject-select" appearance="outline" class="accessible-dropdown">
      <mat-select aria-label="subject selector dropdown" panelClass="accessible-selector" disableOptionCentering
        [value]="subjectSelectedOption" (selectionChange)="updateSubjectSelection($event.value)">
        <mat-option [value]="subjectSelectedOption">
          {{ subjectSelectedOption }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div data-test="Skill Order" class="filter">
    <mat-label>Skill Order</mat-label>
    <mat-form-field id="pendo-skill-order-select" appearance="outline" class="accessible-dropdown">
      <mat-select aria-label="skill order selector dropdown" panelClass="accessible-selector" disableOptionCentering
        [value]="skillOrderSelectedOption" (selectionChange)="updateSkillOrderSelection($event.value)">
        <mat-option *ngFor="let option of skillOrderOptions" [value]="option">
          {{ option }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div data-test="Grade" class="filter">
    <mat-label>Grade</mat-label>
    <mat-form-field id="pendo-grade-select" appearance="outline" class="accessible-dropdown">
      <mat-select aria-label="grade selector dropdown" panelClass="accessible-selector" disableOptionCentering
        [value]="gradeSelectedOption" (selectionChange)="updateGradeSelection($event.value)">
        <mat-option *ngFor="let option of gradeOptions" [value]="option.value">
          {{ option.displayName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
